var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#03A9F4",
    fillRule: "nonzero",
    d: "M14.4.055H1.6c-.88 0-1.6.72-1.6 1.6v12.8c0 .88.72 1.6 1.6 1.6h12.8c.88 0 1.6-.72 1.6-1.6v-12.8c0-.88-.72-1.6-1.6-1.6zm-1.92 5.44v.32c0 3.04-2.32 6.56-6.56 6.56-1.28 0-2.48-.4-3.52-1.04h.56c1.04 0 2.08-.4 2.88-.96-1.04 0-1.84-.72-2.16-1.6.16 0 .32.08.4.08.24 0 .4 0 .64-.08-1.04-.24-1.84-1.12-1.84-2.24.32.16.64.24 1.04.32-.64-.56-1.04-1.2-1.04-2 0-.4.08-.8.32-1.12 1.12 1.36 2.8 2.32 4.72 2.4 0-.16-.08-.32-.08-.56 0-1.28 1.04-2.32 2.32-2.32.64 0 1.28.24 1.68.72.56-.08 1.04-.32 1.44-.56-.16.56-.56.96-1.04 1.28.48-.08.88-.16 1.36-.4-.32.48-.72.88-1.12 1.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fc36904f56c542d5cbc67ddfd6ab83d6.svg";
export { ForwardRef as ReactComponent };